module.exports = __webpack_public_path__ + "static/media/transfer-confirmation.2ef9e262.svg";